import {reduxState}  from 'values';

export const getBanners = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.get_banners,
            data,
        })
    }
}
